import React from "react";
import { useMediaQuery } from "@mui/material";
import { useLocation } from "react-router-dom";
import DesktopNav from "./desktopNav_themed.js";
import MobileNav from "./mobileNav_themed.js";
import Onboarding from "../locations/onboarding/onboarding";
import SubscribeWarning, {
  FreeTrialNotification,
} from "../services/subscribe_warning";
import SelectOrg from "./select_org.jsx";

const Nav = ({ collapsed, setCollapsed }) => {
  const isDesktop = useMediaQuery("(min-width: 600px)");

  const location = useLocation();

  const showNav = !["/signin", "/signup"].includes(location.pathname);

  return (
    <React.Fragment>
      {isDesktop ? (
        <React.Fragment>
          {showNav && (
            <DesktopNav collapsed={collapsed} setCollapsed={setCollapsed} />
          )}
        </React.Fragment>
      ) : (
        <MobileNav />
      )}
      <SubscribeWarning />
      <FreeTrialNotification />
      <Onboarding />
      <SelectOrg />
    </React.Fragment>
  );
};

export default Nav;
